<template>
    <div style="display: flex; flex-direction: column; align-items: center">
        <div style="margin-bottom: 28px">
            <span style="font-size: 22px">发票信息</span>
        </div>
        <div class="jxzb-table" style="width: 100%">
            <div style="text-align: right;padding: 10px;">
			<span>
			<!-- <el-button v-if="type !== 'attachment' && canEdit == 1" icon="el-icon-upload2" @click="opendialog">上传文件</el-button> -->
            <el-button v-table-toxls="views" plain :size="'small'" :file-name="'发票信息'"><svg-icon icon-class="export" />导出</el-button>
			</span>

		</div>
            <!-- <el-table :data="tableData" :span-method="objectSpanMethod" border class="jxzb-tables"> -->
            <el-table id="views" ref="table" :data="tableDataKp" border class="jxzb-tables" @selection-change="handleSelectionChange">
                <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
                <el-table-column type="index" label="序号" width="50" align="center" />
                <!-- <el-table-column prop="projectName" label="项目名称" align="left" :show-overflow-tooltip="true">
                </el-table-column> -->
                <el-table-column prop="corpName" label="付款方名称" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="corpTaxId" label="纳税人识别号" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="bank" label="付款方开户行" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="account" label="付款方银行账号" align="center" :show-overflow-tooltip="true">
                    <!-- <template slot-scope="scope">
                        <span>{{ $moment(scope.row.flCreateDate).format('YYYY年MM月DD日') }}</span>
                    </template> -->
                </el-table-column>
                <el-table-column prop="amount" label="发票金额（元）" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.amount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="drawingDate" label="开票日期" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.drawingDate">{{ $moment(scope.row.drawingDate).format('YYYY年MM月DD日') }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="transactPerson" label="经办人" width="150" align="center" :show-overflow-tooltip="true">
                    <!-- <template slot-scope="scope">
                        <span>{{ $moment(scope.row.drawingDate).format('YYYY年MM月DD日') }}</span>
                    </template> -->
                </el-table-column>
                <el-table-column prop="paymentStatus" label="付款状态" width="100" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ scope.row.paymentStatus === 1 ? '已付款':'待付款' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="margin-bottom: 28px; margin-top: 100px">
            <span style="font-size: 22px">付款明细</span>
        </div>
        <div class="jxzb-table" style="width: 100%">
            <div style="text-align: right; padding: 10px">
                <span>
                    <el-button v-if="type === 'kp' && canEdit == 1" icon="import" @click="importFkmx"> <svg-icon icon-class="import" />导入</el-button>
                     <el-button v-table-toxls="views1" plain :size="'small'" :file-name="'付款明细'"><svg-icon icon-class="export" />导出</el-button>
                    <!-- <el-button v-if="type !== 'attachment' && canEdit == 1" icon="el-icon-download" @click="todownload">批量下载</el-button> -->
                </span>
            </div>
            <!-- <el-table :data="tableData" :span-method="objectSpanMethod" border class="jxzb-tables"> -->
            <el-table id="views1" ref="table" :data="tableDataFk" border class="jxzb-tables" @selection-change="handleSelectionChange">
                <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
                <el-table-column type="index" label="序号" width="50" align="center" />
                <!-- <el-table-column prop="projectName" label="项目名称" align="left" :show-overflow-tooltip="true">
                </el-table-column> -->
                <el-table-column prop="paymentName" label="付款方名称" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="ratepayerNumber" label="纳税人识别号" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="paymentBankDeposit" label="付款方开户行" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="paymentBankCard" label="付款方银行账号" align="center" :show-overflow-tooltip="true">
                    <!-- <template slot-scope="scope">
                        <span>{{ $moment(scope.row.flCreateDate).format('YYYY年MM月DD日') }}</span>
                    </template> -->
                </el-table-column>
                <el-table-column prop="paymentAmount" label="付款金额（元）" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.paymentAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="paymentDate" label="开票日期" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.paymentDate">{{ $moment(scope.row.paymentDate).format('YYYY年MM月DD日') }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="transactPerson" label="经办人" width="150" align="center" :show-overflow-tooltip="true"> -->
                    <!-- <template slot-scope="scope">
                        <span>{{ $moment(scope.row.drawingDate).format('YYYY年MM月DD日') }}</span>
                    </template> -->
                <!-- </el-table-column> -->
                <el-table-column
                    label="操作"
                    width="100"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-link type="primary" @click="glfp(scope.row)"> {{ scope.row.invoiceDetailStatus ?'重新关联' : '关联发票' }}  </el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog title="导入付款明细" :visible.sync="showImport" :destroy-on-close="true" :close-on-click-modal="false" :width="'850'">
            <el-form>
                <div class="el-table el-table--fit el-table--border" style="width: 824px; margin-top: 10px">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="tdlbl tdw17">上传文件</td>
                                    <td class="tdcont tdw83" colspan="5">
                                        <div class="row-col">
                                            <el-upload ref="upload" class="upload-demo" accept=".xls" :action="'/apigw/zbgl/zbxmFkjl/importData?id=' + vo.id" :data="uploadData" :multiple="false" :file-list="fileList" :on-change="fileChange" :on-success="uploadSuccess" :on-remove="removeFile" :auto-upload="false" :with-credentials="true" :show-file-list="true" :disabled="false" :limit="1">
                                                <el-button slot="trigger" type="text">选择文件</el-button>
                                            </el-upload>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="tdlbl tdw100" colspan="6">
                                        <div class="tip">
                                            <span class="light">
                                                1、请先下载
                                                <a :href="downloadTemplateUrl" target="_blank"><span style="color: red; width: 100%">Excel导入示例</span></a>
                                                ；
                                                <br />
                                                2、导入文件应为Office Excel文件；
                                                <br />
                                                3、导入数据填写完整后，请点击【导入】按钮，按照提示上传；
                                                <br />
                                                4、导入文件暂不支持Office 2007及以后版本的Excel文件，如您使用的是Office 2007及以后版本，请把Excel文件转换为2003或之前的版本格式，具体转换方式为：打开的Excel文件中，选择“另存为”->“Excel 97-2003工作簿”；
                                                <br />
                                                5、进行导入操作时，请确保您导入的文件并未处于使用状态。
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain icon="el-icon-close" @click="showImport = false">关闭</el-button>
                <el-button type="primary" :disabled="doing" icon="el-icon-check" @click="startUpload">导入</el-button>
            </div>
        </el-dialog>
        <el-dialog title="导入提示" :visible.sync="showImportResult" :destroy-on-close="true" :close-on-click-modal="false" :width="'850'">
            <div style="line-height: 22px">
                <div>
                    成功导入
                    <span style="color: #67c23a; font-weight: 600">{{ importResult.successCount }}</span>
                    条！
                </div>
                <div>
                    失败
                    <span style="color: #f56c6c; font-weight: 600">{{ importResult.failureCount }}</span>
                    条
                </div>
                <div v-if="importResult.msgList && importResult.msgList.length" style="font-weight: 600">提示信息：</div>
                <template>
                    <div v-for="(item, index) in importResult.msgList" :key="index" style="color: #f56c6c; font-weight: 600">{{ item }}</div>
                </template>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    plain
                    icon="el-icon-close"
                    @click="
                        importResult = {}
                        showImportResult = false
                    "
                >
                    关闭
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="关联发票" :visible.sync="glfpDialogVisible" :destroy-on-close="true" :close-on-click-modal="false" :width="'80%'">
                <div class="content">
                      <el-table ref="table" :data="tableDataKpGl" border class="jxzb-tables" @selection-change="handleSelectionChangeKpGl">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" label="序号" width="50" align="center" />
                <!-- <el-table-column prop="projectName" label="项目名称" align="left" :show-overflow-tooltip="true">
                </el-table-column> -->
                <el-table-column prop="corpName" label="付款方名称" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="corpTaxId" label="纳税人识别号" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="bank" label="付款方开户行" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="account" label="付款方银行账号" align="center" :show-overflow-tooltip="true">
                    <!-- <template slot-scope="scope">
                        <span>{{ $moment(scope.row.flCreateDate).format('YYYY年MM月DD日') }}</span>
                    </template> -->
                </el-table-column>
                <el-table-column prop="amount" label="发票金额（元）" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.amount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="drawingDate" label="开票日期" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                         <span v-if="scope.row.drawingDate">{{ $moment(scope.row.drawingDate).format('YYYY年MM月DD日') }}</span>
                                <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="transactPerson" label="经办人" width="150" align="center" :show-overflow-tooltip="true">
                    <!-- <template slot-scope="scope">
                        <span>{{ $moment(scope.row.drawingDate).format('YYYY年MM月DD日') }}</span>
                    </template> -->
                </el-table-column>
            </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="glfpDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureBtn">关 联</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    filters: {
        filterType(val) {
            if (val == 'ATTACH' || val == 'FORM_ATTACH' || val == 'ZBATTACH') {
                return '其他'
            } else {
                return val
            }
        }
    },
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 0 },
        wfEngineUrl: { type: String, default: null },
        type: { type: String, default: 'detail' }
    },
    data() {
        return {
            tableDataKp: [], // 开票明细
            tableDataKpGl: [], // 开票明细 - 关联
            tableDataFk: [], // 付款明细
            tableData: [],
            multipleSelection: [],
            multipleSelectionKpGl: [], //开票明细 - 关联 已选择
            dialogVisible: false,
            glfpDialogVisible: false,
            selOptions: [
                { label: '代理合同', value: '代理合同' },
                { label: '进场手续', value: '进场手续' },
                { label: '招标(采购)文件', value: '招标(采购)文件' },
                { label: '质疑回复', value: '质疑回复' },
                { label: '中标通知书', value: '中标通知书' },
                { label: '成果文件', value: '成果文件' },
                { label: '投标文件', value: '投标文件' },
                { label: '评价表', value: '评价表' },
                { label: '其他', value: '其他' }
            ],
            fd: '',
            fileList: [],
            disBtn: false,
            fileType: '代理合同',
            showImport: false,
            doing: false,
            uploadData: {},
            importResult: {},
            showImportResult: false,
            downloadTemplateUrl: '/templates/fkjl.xls'
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.wfEngineUrl) {
            this.wfEngineUrl = this.$route.query.wfEngineUrl
        }
        console.log(this.vo, 123123)
    },
    beforeDestroy() {},
    mounted() {
        this.getList()
    },
    methods: {
        sureBtn() {
            if (this.multipleSelectionKpGl.length > 0) {
                this.$http({
                    url: 'zbgl/zbxmFkjl/updateInvoiceApplyById?id=' + this.glRow.id,
                    method: 'post',
                    data: this.multipleSelectionKpGl
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success(res.body.message)
                        this.getList()
                        this.$nextTick(() => {
                            this.glfpDialogVisible = false
                        })
                    }
                })
            } else {
                this.$message.warning('请选择关联发票')
                return false
            }
        },
        glfp(row) {
            this.glRow = {}
            this.glRow = row
            if (row.invoiceDetailStatus) {
                // 释放原先已经关联的  然后查询重新关联
                this.$http({
                    url: 'zbgl/zbxmFkjl/cancelInvoiceApplyById?id=' + row.id,
                    method: 'post'
                }).then(res => {
                    if (res.code === 'success') {
                        this.$http({
                            url: '/cwgl/invoiceApplyItem/querydata',
                            method: 'post',
                            contentType: 'application/x-www-form-urlencoded',
                            data: [{ compare: '=', field: 'projectCode', merge: true, value: this.vo.projectCode }]
                        }).then((res) => {
                            if (res.code === 'success') {
                                this.tableDataKpGl = res.body.listdata
                                if (this.tableDataKpGl.length > 0) {
                                    this.tableDataKpGl = this.tableDataKpGl.filter(item => item.paymentStatus !== 1)
                                    this.$nextTick(() => {
                                        this.glfpDialogVisible = true
                                    })
                                } else {
                                    this.$message.warning('没有符合条件的发票信息')
                                    this.glfpDialogVisible = false
                                }
                            }
                        })
                    }
                })
            } else {
                this.$http({
                    url: '/cwgl/invoiceApplyItem/querydata',
                    method: 'post',
                    contentType: 'application/x-www-form-urlencoded',
                    data: [{ compare: '=', field: 'projectCode', merge: true, value: this.vo.projectCode }]
                }).then((res) => {
                    if (res.code === 'success') {
                        this.tableDataKpGl = res.body.listdata
                        if (this.tableDataKpGl.length > 0) {
                            this.tableDataKpGl = this.tableDataKpGl.filter(item => item.paymentStatus !== 1)

                            this.$nextTick(() => {
                                this.glfpDialogVisible = true
                            })
                        } else {
                            this.$message.warning('没有符合条件的发票信息')
                            this.glfpDialogVisible = false
                        }
                    }
                })
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleSelectionChangeKpGl(val) {
            this.multipleSelectionKpGl = val
        },
        handleUploadChange(file) {
            console.log(file, 123123)
            this.fileList = []
            this.fd = ''
            const fd = new FormData()
            fd.append('file', file.raw)
            this.fd = fd
            this.fileList = [file]
        },
        handleRemove(file, fileList) {
            this.fileList = []
        },
        opendialog() {
            this.fileList = []
            this.dialogVisible = true
        },
        toupload() {
            if (!this.fileType) {
                this.$message.error('请选择文件类型')
                return
            }
            if (this.fileList.length === 0) {
                this.$message.error('请选择文件')
                return
            }
            this.disBtn = true
            const uploadId = this.vo.id
            this.fileList.forEach((item) => {
                const fd = new FormData()
                fd.append('file', item.raw)
                fd.append('module', 'zbxmArch')
                fd.append('busiDataId', uploadId)
                fd.append('attachsType', this.fileType)
                fd.append('clientType', 'uploader')
                fd.append('attachsName', item.name)
                fd.append('fileType', this.fileType)
                this.$http({
                    method: 'post',
                    url: this.wfEngineUrl + '/upload',
                    data: fd,
                    params: {
                        fileType: this.fileType
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.getList()
                        this.disBtn = false
                        this.dialogVisible = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        getList() {
            //开票明细
            this.$http({
                url: '/cwgl/invoiceApplyItem/querydata',
                method: 'post',
                contentType: 'application/x-www-form-urlencoded',
                data: [{ compare: '=', field: 'projectCode', merge: true, value: this.vo.projectCode }]
            }).then((res) => {
                if (res.code === 'success') {
                    this.tableDataKp = res.body.listdata
                    this.tableDataKpGl = this.tableDataKp
                }
            })
            //付款明细
            this.$http({
                url: '/zbgl/zbxmFkjl/querydata',
                method: 'post',
                contentType: 'application/x-www-form-urlencoded',
                data: [{ compare: '=', field: 'projectCode', merge: true, value: this.vo.projectCode }]
            }).then((res) => {
                if (res.code === 'success') {
                    this.tableDataFk = res.body.listdata
                }
            })
        },
        importFkmx() {
            this.showImport = true
        },
        // 选择文件
        fileChange(file, files) {
            this.fileList = [file]
            this.doing = false
        },
        //删除文件
        removeFile(file, files) {
            this.fileList = []
        },
        // 导入
        startUpload() {
            this.showImport = true
            if (this.fileList.length === 0) {
                this.$alert('请选择导入文件', '操作提示', { type: 'warning' })
            } else {
                this.doing = true
                this.$refs.upload.submit()
            }
        },
        // 上传成功
        uploadSuccess(response, file, fileList) {
            this.showImport = true
            if (response.code === 'success') {
                this.showImport = false
                this.$bus.emit('refreshListData')
                this.importResult = response.body
                this.showImportResult = true
            } else {
                this.$alert(response.message, '操作提示', { type: 'error' })
            }

            this.doing = false

            this.fileList = null
            this.$nextTick(() => {
                this.fileList = []
                this.getList()
            })
        },
        todownload(row) {
            console.log(this.multipleSelection, row.atttachId, 'this.multipleSelection')
            if (this.multipleSelection.length === 0 && row.atttachId === undefined) {
                return this.$message.error('请选择要下载的文件')
            }
            if (this.multipleSelection.length > 0) {
                const rowid = this.multipleSelection.map((item) => item.atttachId).join(',')
                window.open('apigw/' + this.wfEngineUrl + '/downloadById?attachIds=' + rowid)
                this.$refs.table.clearSelection()
                this.multipleSelection = []
            } else {
                window.open('apigw/' + this.wfEngineUrl + '/downloadById?attachIds=' + row.atttachId)
                this.$refs.table.clearSelection()
                this.multipleSelection = []
            }
        },
        openwork(row) {
            window.open('apigw/' + this.wfEngineUrl + '/downloadById?attachIds=' + row.atttachId)
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';
</style>
<style>
.upload-demo .el-upload--text {
    float: left;
}
.upload-demo .el-upload-list--text {
    float: left;
    margin-left: 10px;
    margin-top: 7px;
}
.upload-demo .el-upload-list--text .el-upload-list__item:first-child {
    margin-top: 0;
}
.el-form .el-table__body .tdlbl .tip {
    text-align: left;
    line-height: 28px;
}
</style>
